import { onAuthStateChanged } from '@firebase/auth'
import { doc, onSnapshot, Unsubscribe } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAds } from '@/contexts/ads'
import { auth, firestore } from '@/services/firebase.service'
import { useActionless } from '@/store/hooks'
import { SET_USER_STATE_FULL, SIGN_OUT } from '@/store/user/actions/types'
import { UserStateType } from '@/store/user/initialState'
import { sha1Encode } from '@/utils/helpers'

const mvIdentityAPI = async (emailHash: string) => {
  try {
    // @ts-ignore
    await window.$adManagementConfig.web.identityOptIn({ email: emailHash })
  } catch {
    window.addEventListener('mediavineIdentityReady', async () => {
      // @ts-ignore
      await window.$adManagementConfig.web.identityOptIn({ email: emailHash })
    })
  }
}

let unsub: Unsubscribe | undefined

const FirebaseAuth = () => {
  const dispatch = useDispatch()
  const { loadAds } = useAds()
  const [setUserStateFull] = useActionless(SET_USER_STATE_FULL)
  const [emailHash, setEmailHash] = useState<string | null>(null)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setEmailHash(await sha1Encode(user.email as string))

        unsub = onSnapshot(doc(firestore, 'users', user.uid), (doc) => {
          const data = doc.data() as UserStateType
          setUserStateFull({ ...data, uid: user.uid }) // Use subobject reference to avoid stale callback
        })
      } else {
        dispatch({ type: SIGN_OUT })

        if (unsub) {
          unsub()
        }
      }
    })
  }, [])

  // Calls MV Identity API once per session, if logged in and ads are enabled
  useEffect(() => {
    if (emailHash && loadAds === true && !isInitialized) {
      setIsInitialized(true)
      mvIdentityAPI(emailHash)
    }
  }, [emailHash, loadAds])

  return null
}

export default FirebaseAuth
